<script lang="ts">

    import Modal from "@/components/Modal.svelte";
    import RelatedSingle from "@/components/Inputs/RelatedSingle.svelte";
    import {Button} from "@/components/ui/button";
    import Input from "@/components/Form/Inputs/Input.svelte";
    import FormContainer from "@/components/Form/FormContainer.svelte";
    import FormBlock from "@/components/Form/FormBlock.svelte";
    import CustomerTable from "@/components/customers/CustomerTable.svelte";
    import type Blocks from "@/schemas/public/Blocks";
    import type {Field} from "@/types/types";
    import {toast} from "svelte-sonner";
    import {useForm} from "@inertiajs/svelte";
    import MultiRelated from "@/components/Inputs/MultiRelated.svelte";
    import {SvelteMap} from "svelte/reactivity";
    import Select from "@/components/Inputs/Select.svelte";
    import Textarea from "@/components/Inputs/Textarea.svelte";
    import { parseFieldOptions } from '@/lib/fieldUtils';

    type Props = {
        blocks: (Blocks & { fields: Field[] })[];
        show: boolean;
        relatedRecordId?: string | null;
        relatedRecordLabel?: string | null;
    }

    let {blocks, show = $bindable(), relatedRecordId, relatedRecordLabel}: Props = $props();


    let createFormInner: Record<string, any> = {}
    for (const block of blocks) {
        for (const field of block.fields) {
            createFormInner[field.column_name] = null;
        }
    }
    createFormInner['customer_id'] = relatedRecordId ?? null;
    let createForm = $state(useForm(createFormInner));

    let isSelectCustomerOpen = $state(false);
    let customerLabel: string | null = $state(relatedRecordLabel ?? null);
    let selectedRelatedCustomers = $state(new SvelteMap<string, string>());

    function close() {
        show = false;
    }

    function submit(e) {
        $createForm.processing = true;
        e.preventDefault();
        $createForm.post(route('sites.store'), {
            onSuccess: () => {
                close();
                $createForm.reset();
                toast.success("Site created successfully!");
            },
            onError: (errors) => {
                for (const message of Object.values(errors)) {
                    toast.error("Error creating site. " + message as string);
                }
            }
        });
    }

</script>
{#if show}
    <Modal title="Add New Site" onClose={close}>
        <FormContainer>
            <form onsubmit={submit}>
                {#each blocks as block}
                    <FormBlock label={block.label}>
                        {#each block.fields as field}
                            {#if field.editable}
                                {#if field.ui_type === 'related'}
                                    <RelatedSingle
                                        label={field.label}
                                        bind:value={$createForm[field.column_name]}
                                        error={$createForm.errors[field.column_name]}
                                        bind:isOpen={isSelectCustomerOpen}
                                        bind:valLabel={customerLabel}
                                    >
                                        <CustomerTable
                                            view="related"
                                            onRowClick={(row) => {
                                                $createForm.customer_id = row?.id ?? null;
                                                customerLabel = row?.first_name ?? '';
                                                isSelectCustomerOpen = false;
                                            }}
                                        />
                                    </RelatedSingle>
                                {:else if field.ui_type === 'multi_related'}
                                    <MultiRelated
                                        label={field.label}
                                        bind:value={$createForm[field.column_name]}
                                        error={$createForm.errors[field.column_name]}
                                        bind:isOpen={isSelectCustomerOpen}
                                        bind:valLabel={customerLabel}
                                    >
                                        <CustomerTable
                                            view="multi_related"
                                            onRowClick={(row) => {
                                                // $form.customer_id = row?.id ?? null;
                                                // customerLabel = row?.first_name ?? '';
                                                // isSelectCustomerOpen = false;
                                            }}
                                            bind:selectedCustomers={selectedRelatedCustomers}
                                            onSubmitClick={() => {
                                                $createForm.customers = selectedRelatedCustomers.keys().toArray();
                                                customerLabel = Array.from(selectedRelatedCustomers.values()).join(", ");
                                                isSelectCustomerOpen = false;
                                            }}
                                        />
                                    </MultiRelated>
                                {:else if field.ui_type === 'select'}
                                    <Select
                                        label={field.label}
                                        bind:value={$createForm[field.column_name]}
                                        options={parseFieldOptions(field)}
                                        error={$createForm.errors[field.column_name]}
                                    />
                                {:else if field.ui_type === 'textarea'}
                                    <Textarea
                                        label={field.label}
                                        bind:value={$createForm[field.column_name]}
                                        error={$createForm.errors[field.column_name]}
                                    />
                                {:else}
                                    <Input
                                        field={field}
                                        bind:value={$createForm[field.column_name]}
                                        error={$createForm.errors[field.column_name]}
                                        onkeydown={() => {}}
                                    />
                                {/if}
                            {/if}
                        {/each}
                    </FormBlock>
                {/each}

                <div class="mt-5 flex justify-end gap-2">
                    <Button type="button" onclick={close}>Cancel</Button>
                    <Button type="submit" disabled={$createForm.processing}>
                        {#if $createForm.processing}Saving...{:else}Save{/if}
                    </Button>
                </div>
            </form>
        </FormContainer>
    </Modal>
{/if}
